import axios from "axios";
import { parse } from "date-fns";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";

const AddDeliveryChargesModal = ({
  isOpen,
  onClose,
  onAddProduct,
  setCode,
}) => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [internalNotes, setInternalNotes] = useState("");

  const [selectedPricingValue, setSelectedPricingValue] = useState("");
  const [projectSelectDate, setProjectSelectedDate] = useState("");
  const [projectSelectedHour, setProjectSelectedHour] = useState("12");
  const [projectSelectedMinute, setProjectSelectedMinute] = useState("00");
  const [projectSelectedPeriod, setProjectSelectedPeriod] = useState("AM");

  const generateRandomId = () => {
    return Math.floor(100000 + Math.random() * 900000); // Generates a 6-digit number
  };

  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          "https://server-gs.vercel.app/event-company-tax-value"
        );
        setData(response.data);
        setError(null); // Clear any previous errors
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        // setLoading(false);
      }
    };

    // Fetch data every second
    const intervalId = setInterval(fetchData, 1000);

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  const handleAddProduct = () => {
    const dateString = `${projectSelectDate} ${projectSelectedHour}:${projectSelectedMinute} ${projectSelectedPeriod}`;
    const combinedStartDate = parse(
      dateString,
      "yyyy-MM-dd hh:mm a",
      new Date()
    ).toISOString();

    console.log("Combined Start Date:", combinedStartDate);

    const newProduct = {
      productId: generateRandomId().toString(),
      productCode: generateRandomId(),
      title,
      quantity: "1",
      description,
      internalNotes,
      tax: "0",
      discount: "0",
      discountType: "$",
      selectedPricingValue,
      deliveryType: "delivery",
      startDate: combinedStartDate,
    };

    onAddProduct(setCode, newProduct);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0  flex justify-center items-center font-roboto ">
      <div className="bg-gray-100 rounded-2xl shadow-2xl w-[50%] ">
        {/* Header */}
        <div className="flex flex-row justify-between items-center px-6 py-4 bg-gradient-to-r bg-blue-600 rounded-t-2xl">
          <h2 className="text-xl font-bold text-white">Add Delivery</h2>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-blue-700 transition-colors duration-200"
          >
            <img
              className="w-4 h-4"
              alt="Close"
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgMzI5LjI2OSAzMjkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTIiIHhtbDpzcGFjZT0icHJlc2VydmUiIGNsYXNzPSIiPjxnPjxwYXRoIGQ9Ik0xOTQuOCAxNjQuNzcgMzIzLjAxMyAzNi41NTVjOC4zNDMtOC4zNCA4LjM0My0yMS44MjUgMC0zMC4xNjQtOC4zNC04LjM0LTIxLjgyNS04LjM0LTMwLjE2NCAwTDE2NC42MzMgMTM0LjYwNSAzNi40MjIgNi4zOTFjLTguMzQ0LTguMzQtMjEuODI0LTguMzQtMzAuMTY0IDAtOC4zNDQgOC4zNC04LjM0NCAyMS44MjQgMCAzMC4xNjRsMTI4LjIxIDEyOC4yMTVMNi4yNTkgMjkyLjk4NGMtOC4zNDQgOC4zNC04LjM0NCAyMS44MjUgMCAzMC4xNjRhMjEuMjY2IDIxLjI2NiAwIDAgMCAxNS4wODIgNi4yNWM1LjQ2IDAgMTAuOTIyLTIuMDkgMTUuMDgyLTYuMjVsMTI4LjIxLTEyOC4yMTQgMTI4LjIxNiAxMjguMjE0YTIxLjI3MyAyMS4yNzMgMCAwIDAgMTUuMDgyIDYuMjVjNS40NiAwIDEwLjkyMi0yLjA5IDE5LjA4Mi02LjI1IDguMzQzLTguMzQgOC4zNDMtMjEuODI0IDAtMzAuMTY0em0wIDAiIGZpbGw9IiNmZmZmZmYiIG9wYWNpdHk9IjEiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSIiPjwvcGF0aD48L2c+PC9zdmc+"
            />
          </button>
        </div>

        {/* Body */}
        <div className="grid grid-cols-2 gap-5 p-6">
          {/* Product Title */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Delivery Title
            </label>
            <input
              type="text"
              placeholder="Product Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            />
          </div>
          {/* Selected Pricing Value */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Delivery Charge
            </label>
            <input
              type="number"
              placeholder="Selected Pricing Value"
              value={selectedPricingValue ?? ""}
              onChange={(e) => {
                const value = e.target.value;

                // Allow empty input for smooth deletion
                if (value === "") {
                  setSelectedPricingValue(null);
                  return;
                }

                // Parse to float and check for non-negative value
                const parsedValue = parseFloat(value);
                if (!isNaN(parsedValue) && parsedValue >= 0) {
                  setSelectedPricingValue(parsedValue);
                }
              }}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
            />
          </div>
          {/* Description */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Description
            </label>
            <textarea
              placeholder="Description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
            />
          </div>

          {/* Internal Notes */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Internal Notes
            </label>
            <textarea
              placeholder="Internal Notes"
              value={internalNotes}
              onChange={(e) => setInternalNotes(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent transition-all duration-200"
            />
          </div>
          {/* Start Date */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Start Date
            </label>
            <input
              type="date"
              value={projectSelectDate}
              onChange={(e) => setProjectSelectedDate(e.target.value)}
              className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
            />
          </div>

          {/* Start Time */}
          <div>
            <label className="block font-roboto text-md text-gray-900 mb-2">
              Start Time
            </label>
            <div className="flex gap-2">
              <select
                value={projectSelectedHour}
                onChange={(e) => setProjectSelectedHour(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              >
                {Array.from({ length: 12 }, (_, i) => i + 1).map((hour) => (
                  <option key={hour} value={hour < 10 ? `0${hour}` : hour}>
                    {hour < 10 ? `0${hour}` : hour}
                  </option>
                ))}
              </select>
              <select
                value={projectSelectedMinute}
                onChange={(e) => setProjectSelectedMinute(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              >
                {Array.from({ length: 12 }, (_, i) => i * 5).map((minute) => (
                  <option
                    key={minute}
                    value={minute < 10 ? `0${minute}` : minute}
                  >
                    {minute < 10 ? `0${minute}` : minute}
                  </option>
                ))}
              </select>
              <select
                value={projectSelectedPeriod}
                onChange={(e) => setProjectSelectedPeriod(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all"
              >
                <option value="AM">AM</option>
                <option value="PM">PM</option>
              </select>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 flex justify-start bg-gray-50 border-t border-gray-200">
          <button
            onClick={handleAddProduct}
            className="w-56 py-3 font-roboto  bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg focus:ring-4 focus:outline-none focus:ring-blue-300 transition-all"

>
            Add Delivery
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddDeliveryChargesModal;
